<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <strong>User</strong>
          </CCardHeader>
          <CRow>
            <CCol md="6">
              <CCardBody>
                <CForm>
                
                  <CInput
                    label="Display Name"
                    v-model="user.displayName"
                    horizontal
                    :disabled="mode.viewMode"
                  />
                 

                  <CInput
                    label="Email"
                    placeholder="Email..."
                    v-model="user.email"
                    horizontal
                    :disabled="mode.viewMode"
                  />

                   <CInput
                    label="Phone Number"
                    placeholder="Phone Number..."
                    v-model="user.phoneNumber"
                    horizontal
                    :disabled="mode.viewMode"
                  />

                  <CInputFile
                    label="Profile Pic"
                    horizontal
                    type="file"
                    :disabled="mode.viewMode"
                    accept="image/*"
                    @change="uploadImage"
                  />

                  

                  <CRow>
                    <CCol md="3"></CCol>
                    <CCol md="9" align="center">
                      <CCard
                        v-if="user.profilePicId && !$v.user.profilePicId.$error"
                        style="margin-top: 20px"
                      >
                        <CCardBody align="center">
                          <CButton color="danger" style="float: right" @click="removeimage() ">
                            <CIcon name="cilXCircle" description="Delete"></CIcon>
                          </CButton>
                          <CImg
                            v-if="user.profilePicId"
                            :src="imageUrl(user.profilePicId)"
                            height="180px"
                            alt="Responsive image"
                            :disabled="mode.viewMode"
                          ></CImg>
                        </CCardBody>
                      </CCard>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCol>
            <CCol md="6">
              <CCardBody>
                <!-- <CForm>
                  <CFormGroup class="form-group form-row">
                    <template #label>
                      <slot name="label">
                        <label class="col-form-label col-sm-12 col-md-3">Authorities</label>
                      </slot>
                    </template>
                    <template #input>
                      <div :class="{'col-sm-12 col-md-9':true}">
                        <multiselect
                          :options="roles"
                          :multiple="true"
                          :hide-selected="true"
                          track-by="name"
                          label="name"
                        ></multiselect>
                        <div class="invalid-feedback">Select atleast a category</div>
                      </div>
                    </template>
                  </CFormGroup>
                </CForm> -->
              </CCardBody>
            </CCol>
          </CRow>

          <CCardFooter align="right">
            <CButton class="mr-2" type="Cancel" size="sm" color="danger" @click="cancel()">
              <CIcon name="cil-ban" />Cancel
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
export default {
  name: "User",
  data() {
    return {
      mode: {
        newMode: false,
        editMode: false,
        viewMode: false,
      },
      userId: "",
      user: {
        firstName: "",
        userName: "",
        lastName: "",
        email: "",
        role: "",
      },
      categories: [],
      selected: [],
      // roles: [],
      // selectedRoles: [],
      show: true,
      horizontal: { label: "col-3", input: "col-9" },
    };
  },
  created() {
    if (this.$route.params.mode == "view") {
      this.mode.viewMode = true;
      this.userId = this.$route.params.userId;
      this.getUser();
    }
  },
  methods: {
    editMode() {
      this.mode.editMode = true;
      this.mode.viewMode = false;
    },
    cancel() {
      this.$router.push({ name: "AppUsers" });
    },
    validator(val) {
      return val ? val.length >= 4 : false;
    },
    removeimage() {
      this.user.profilePicId = "";
    },
    imageUrl(image) {
      console.log(image);
      return process.env.VUE_APP_API_HOST + "/file/" + image;
    },
    uploadImage(files, event) {
      const URL = process.env.VUE_APP_API_HOST + "/file/upload";
      console.log("uploadImage", URL);
      console.log("files", files);
      console.log("event", event);
      let fdata = new FormData();
      fdata.append("file", files[0]);

      fetch(URL, {
        method: "POST",
        body: fdata,
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("image upload response > ", data);
          this.user.profilePicId = data.data.fileId;
        });
    },
    getUser() {
      this.apiGetSecure(
        process.env.VUE_APP_API_HOST + "/web/secure/get/user/" + this.userId
      )
        .then((response) => response.json())
        .then((data) => (this.user = data));
    },
    // getRoles() {
    //   this.apiGetSecure(process.env.VUE_APP_API_HOST + "/web/secure/meta/roles")
    //     .then((response) => response.json())
    //     .then((data) => (this.roles = data));
    // },
  },
  mounted() {
    // this.getRoles();
  },
};
</script>
